module.exports = __webpack_public_path__ + "4974d7552053bdb1f16fd6c9c794be10.png";